import request from "@/utils/request"

// 查询增值服务信息列表
export function getWareList(query) {
  return request({
    url: "/server/ware/list",
    method: "get",
    params: query,
  })
}
// 查询增值服务信息列表
export function addWare(data) {
  return request({
    url: "/server/ware/add",
    method: "post",
    data: data,
  })
}
// 查询增值服务信息列表
export function auditWare(data) {
    return request({
      url: "/server/ware/audit",
      method: "post",
      data: data,
    })
  }
  